import { UserMessages } from "definitions/Locale"

const newUserMessages: UserMessages = {
  es: {
    translations: {
      loading: "Carregando",
      selectTicketType: "Tipo de atendimento",
      statusForRefusedChat: "Status para chat rechazado por el cliente",
      selectTemplateToSeeMessage: "Seleccione un template para ver la mensagem",
      selectTemplate: "Seleccione un template",
      chooseCompany: "Escolha a companhia",
      messageSentToCustomer: "Mensaje enviado exitosamente",
      stayOnThisPage: "Permanezca en esta página al enviar",
      toClose: "cerrar",
      sendWhatsappMessageToCustomerModalTitle: "Enviar un mensaje al",
      enterKeySendsMessage:
        "La tecla Intro envía el mensaje (presione con CTRL o MAYÚS para obtener una nueva línea)",
      confirmPostImage:
        "¿Confirmar el envío de la imagen pegada desde el portapapeles?",
      readAll: "Lee todo",
      operator: "Atendente",
      newUserHeader: "Registrar usuario",
      profileHeader: "Perfil",
      welcomeHeader: "Bienvenido al",
      loginHeader: "ACESSO",
      changePassword: "Cambiar clave",
      inOpen: "En abierto hoy",
      awaitingClient: "Esperando al cliente",
      inAttendance: "En asistencia",
      apparence: "Apariencia",
      newPassword: "Nueva senha",
      perTimeTicket: "registros por vez",
      openIntegrationError: "Essa empresa não existe no open.",
      show: "Mostrar",
      closed: "Cerrando",
      callData: "Datos del llamados",
      clientData: "Datos del cliente",
      searchClient: "Buscar cliente",
      selectTicket: "Seleccione un ticket",
      howCanHelp: "¿En que puedo ayudar?",
      confirmReproveCompany: "¡Sí, quiero fallar!",
      infoToStart: "Para empezar, necesitamos información inicial.",
      config: "Ajustes",
      fantasy: "Fantasía",
      responsible: "Responsable",
      clients_export: "Clientes - Exportar",
      clients_import: "Clientes - Importación",
      action: "Acción",
      sendDate: "Fecha de envío",
      attDate: "Fecha de actualización",
      clients: "Clientes",
      implementCode: "Código de implementación",
      implementCodeSkute: "Código de implementación do widget",
      putExclude: "Digite EXCLUIR para continuar",
      registry: "Registro",
      ignored: "Ignorado",
      number: "Número",
      category: "Categoria",
      login: "Acesso",
      name: "Nombre",
      logo: "Logo",
      nickname: "Apelido",
      contact: "Contato",
      bornDate: "Nacimiento",
      document: "Cl",
      email: "Correo electrónico",
      profile: "Perfil",
      company: "Empresa",
      initialPassword: "Contraseña inicial",
      date: "Fecha",
      password2: "Clave",
      confirmPassword: "Confirmar clave",
      cellphone: "Móvil",
      userActive: "Activo",
      secundaryEmail: "Email Secundario",
      phone: "Teléfono",
      branch: "extensión",
      zipCode: "Código postal",
      address: "Dirección",
      complement: "Complemento",
      neighborhood: "Vecindario",
      city: "Ciudad",
      state: "Región",
      sellEmail: "E-Mail ventas",
      scheduling: "Citas",
      companyReturnContact: "¿La empresa ha devuelto el contacto?",
      currectData: "¿Son correctos los datos?",
      confirmEmailGeneration:
        "¿Quieres generar un correo electrónico para el cliente?",
      emailGenerationText:
        "El cliente no tiene una dirección de correo electrónico ¿Quieres generar una dirección de correo electrónico automática?",

      inactive: "Inactivo",
      wantSave: "¡Sí, quiero guardar!",
      newContact: "Nuevo contacto",
      Contact: "Contacto",
      finalRegister: "Registro final",
      status: "Status",
      search: "Buscar",
      standardColor: "Cor estándar",
      backgroundColor: "Color de fondo",
      answerBoxColor: "Color del cuadro de respuesta del usuario",
      companyBoxColor: "Color del cuadro de respuesta de la empresa",
      socialReason: "Razón social",
      site: "URL",
      text: "Texto",
      answerExample: "Respuesta ej: (1) o (2)",
      goToOperator: "Ir al agente",
      endOfBot: "Fin del bot",
      backToStart: "De regreso al principio",
      onlyOneChild: "solo una interacción como una hija.",
      removeChildsFirst: "Primero quite a los niños para quitar al padre",
      description: "Descripción",
      wordsToAddOperator:
        'Palabras para activar al asistente (separadas por ",")',
      numberOfTries: "Número de intentos antes de direccionar al agente",
      wordsToRedirect: "Reenvío de mensajes al agente",
      callDistribution: "Las llamadas se distribuyen automáticamente a cada",
      calls: "llamada.",
      callNotDistribution: "Las llamadas no se distribuyen automáticamente",
      user: "Usuário",
      password: "Contraseña",
      save: "Guardar",
      resetPassword: "Restablecer la contraseña",
      getBack: "Vuelve",
      openInOpen: "Abrir en OPEN",
      confirm: "Confirmar",
      unify: "Unificar",
      unifyClient: "Unificar cliente",
      assume: "Assumir",
      assumeTicket: "Assumir Ticket",
      exportClient: "EXPORTAR CLIENTES",
      start: "Iniciar",
      importClients: "IMPORTAR CLIENTES",
      cancel: "Cancelar",
      downloadModel: "DESCARGAR MODELO",
      newClient: "NUEVO CLIENTE",
      add: "Agregar",
      clickToStart: "Haz click aquí para comenzar",
      language: "Idioma",
      select: "Seleccione",
      genderOption: "Sexo",
      rememberEmail: "E-mail Recordatorio",
      activeCall: "Llamada activa",
      type: "Tipo",
      subType: "Sub-Tipo",
      redirectCall: "Desviar llamada",
      callStatus: "Status de llamada",
      answerType: "Tipo de respuesta",
      shortcuts: "Atajos",
      empty: "Selecciona un idioma",
      portuguese: "Portugués",
      spanish: "Español",
      genderMenOption: "Masculino",
      genderFemaleOption: "Femenino",
      genderNotInformed: "Não Informado",
      yes: "Sí",
      no: "No",
      emptyChannels: "No se encontraron canales",
      selectChannel: "Seleccione el canal",
      createNew: "Crear nuevo",
      chooseOne: "Seleccione uno",
      menuOption: "Opción de menú",
      image: "Imagem",
      languageChange: "La página se volverá a cargar para aplicar los cambios.",
      forgotPassword: "Olvido la contraseña?",
      archive: "Archivo",
      publications: "No hay publicaciones nuevas",
      notifications: "Notificaciones",
      exit: "Salir",
      noCompanyRegistered: "Sin empresas registradas",
      noExportationFinded: "No se encontraron exportaciones",
      noImportationsFinded: "No se encontraron importaciones",
      errors: "Errores",
      allowAttUsers: "Le permite actualizar usuarios",
      ifAllow:
        "Al permitir que el usuario se actualice, si se encuentra Cl / Registro en la base de datos, los datos del cliente se actualizarán.",
      noClientsRegistered: "No hay clientes registrados",
      picture: "Foto",
      noChannelsFinded: "No se encontraron canales",
      channel: "Canales",
      deadLine: "Término en",
      attendanceBot: "Bot de servicio",
      quantity: "Cantidad",
      createBot: "Crear bot",
      editBot: "Editar bot",
      attemption: "Aviso",
      confirmUnify: "¿Está seguro de que desea unificar sus registros?",
      acceptUnify: "¡Sí, quiero unificar!",
      eraseCompany: "¿Está seguro de que desea eliminar esta empresa?",
      approved: "Aprobado",
      confirmEraseCompany: "¡Sí, quiero confirmar!",
      eraseClient: "¿Está seguro de que desea eliminar este cliente?",
      desire: "Que deseas ?",
      edit: "Editar",
      create: "Crear",
      delete: "Borrar",
      deleteDesire: "¿estas seguro que quieres borrarlo?",
      deleteHolliday: "¿Estás seguro de que deseas eliminar este feriado ?",
      noHollidayFinded: "No se encontraron feriados.",
      deleteHours: "¿Está seguro de que desea eliminar estas horas?",
      businessHoursNotFound: "No se encontraron horas",
      startHour: "Hora de inicio",
      endHour: "Hora de finalización",
      days: "Día(s)",
      invalidHour: "¡Horas de servicio no válidas!",
      startHourFinalHour:
        "¡La hora de inicio debe ser menor que la hora de finalización!",
      selectOneDay: "¡Seleccione al menos un día de la semana!",
      sunday: "Domingo",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miércoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sábado",
      title: "Título",
      message: "Mensaje",
      deleteShortcut: "¿Está seguro de que desea eliminar este acceso directo?",
      noShortcutFinded: "No se encontraron atajos",
      deleteFeed: "¿Estás seguro de que quieres eliminar este Feed?",
      exportAllData: "Exportar todos los datos",
      totalPauses: "Total de pausas",
      totalPausesDuration: "Tiempo total de pausa (HH:MM:SS)",
      deleteSLA: "¿Está seguro de que desea eliminar este SLA?",
      noSLAFinded: "No se encontró ningún SLA",
      externalDescription: "Descripción externa",
      internalDescription: "Descripción internal",
      deleteStatus: "¿Está seguro de que desea eliminar este estado?",
      noStatusFinded: "No se encontró ningún status",
      default: "predefinido",
      defaultTicket:
        "¿Está seguro de que desea establecer este tipo de ticket como predeterminado?",
      defaultType: "Tipo estándar de atención",
      deleteTicket: "¿Estás seguro de que deseas eliminar este tipo de ticket?",
      noTicketFinded: "No se encontraron tipos de tickets",
      defaultTicketType: "Tipo estándar",
      delay: "Retraso",
      superDelay: "Super retraso",
      delayRisk: "Riesgo de retraso",
      openingHour: "Horarios de atención",
      holliday: "Feriados",
      callsDistribution: "Configuração de ambiente",
      userTypes: "Tipos de usuário",
      ticketType: "Tipo de ticket",
      attendanceShortcut: "Atajos de servicio",
      bot_config: "Bot - Apariencia",
      deleteUserType:
        "¿Estás seguro de que deseas eliminar este tipo de usuario ?",
      noUserTypeFinded: "No se encontró ningún tipo de usuario",
      loggedOperators: "Agentes registrados",
      expiredSLA: "SLA Caducado",
      concluded: "Terminados hoy",
      awaiting: "En espera",
      tickets: "En atención",
      averageToday: "Promedio hoy",
      maximunToday: "Máximo hoy",
      deleteScheduling: "¿Está seguro de que desea eliminar esta programación?",
      inQueue: "En la cola",
      attendance: "Servicio",
      ticketsOppenedTodayByChannel: "Entradas abiertas hoy por canal",
      newCompany: "Registrar empresa",
      ticketsOppenedTodayByType: "Entradas abiertas hoy por tipo",
      partner: "Socio",
      noPartner: "No socio",
      noBelong: "No es parte",
      perChannel: "Por canal",
      startDate: "Fecha de inicio",
      endDate: "Fecha final",
      noInfoFinded: "No se encontró información",
      perState: "Por región",
      perProtocolType: "Por tipo de protocolo",
      byUser: "Por cliente",
      about: "Acerca de",
      subtitle: "Subtítulo",
      productsAndServices: "Productos y Servicios",
      event: "Evento",
      attachment: "Archivo anexo",
      externalSite: "Sitio externo",
      linkText: "Texto del enlace",
      preview: "Vista prévia",
      previewFeed: "Vista previa de feed en SKUTE",
      noFeedFinded: "No se encontró ningún feed.",
      createdAt: "Creado en",
      eventsRegistry: "Registro de eventos",
      likes: "Acción",
      assessments: "Evaluaciones",
      backToBusiness: "¿Volvería a hacer negocios?",
      backToBusiness2: "Volvería a hacer negocios",
      comentary: "Comentario",
      replic: "Réplica",
      reject: "Rechazar",
      approve: "Aprobar",
      comentaryRejected:
        "Los comentarios rechazados no aparecen en la página de la empresa, pero su puntuación se considera.",
      all: "Todas",
      NoReviewsFound: "No se encontraron comentarios",
      noSchedulingFound: "No se encontraron citas.",
      deleteSheduling: "¿Está seguro de que desea eliminar esta cita?",
      protocol: "Protocolo",
      deleteUser: "¿Está seguro de que desea eliminar este usuario?",
      noUsersFound: "No hay usuarios registrados",
      photo: "Foto",
      shedulingToday: "Citas de hoy",
      perStatus: "Por status - Hoy",
      perLate: "Vencido - Hoy",
      late: "Vencido",
      avaliations: "SKUTE - Mis críticas",
      schedulingperWeek: "Asistencia por semana",
      latePerWeek: "Vencido en la semana",
      january: "Enero",
      february: "Febrero",
      march: "Marcha",
      april: "Abril",
      may: "Mayo",
      june: "Junio",
      july: "Julio",
      august: "Agosto",
      september: "Septiembre",
      october: "Octubre",
      november: "Noviembre",
      december: "Diciembre",
      send: "Enviar",
      informALogin: "Introduzca un nombre de usuario.",
      minimumPassword: "La contraseña debe tener al menos 5 caracteres.",
      passwordNotMatch: "¡Las contraseñas no coinciden!",
      none: "Ninguno",
      doesNotHaveBot: "No tiene bot",
      successCopy: "¡Texto copiado en su portapapeles!",
      reprove: "Fallar",
      pending: "Pendiente",
      reproveDesire:
        "¿Estás seguro de que quieres hacer fracasar a esta empresa?",
      ticketOcorrency: "Hay casos abiertos para este cliente.",
      updatedAt: "Actualizado en",
      hideTopMenu: "Ocultar el menú",
      systemVariables: "Variables del sistema",
      backToLogin: "Volver al login",
      showTopMenu: "Muestrame el menu",
      returnPausePassword: "Requerir autenticación al regresar de la pausa",
      today: "Hoy",
      yesterday: "Ayer",
      onlyPending: "Solo pendiente",
      showInactive: "Solo activos",
      userType: "Tipo de usuario",
      noPermission: "No tienes permiso",
      customFields: "Campos personalizados",
      searchPerAttendant: "Buscar por asistente",
      noAgentOnline: "Sin asistentes en línea.",
      reload: "Actualizar",
      callAgent: "llamar o agente",
      errorsBeforeAgent: "Errores ante el agente",
      messageToAgent: "Reenvío de mensaje al agente",
      noBotFinded: "No se encontraron bots",
      confirmEraseBot: "¡Sí, confirma!",
      deleteBot: "¿Estás seguro de que deseas eliminar el bot?",
      noCallOperator: "No hay opción para llamar al operador.",
      nextStep: "Próximo Passo",
      selectOperator: "Seleccione la operadora",
      anyOperator: "Cualquier operadora",
      backStep: "Paso Atrás",
      doubleInteractionOption:
        "No se puede crear una opción de menú en otra opción de menú.",
      question: "Pregunta",
      option: "opción",
      concludedStatus: "Estatus da conclusão",
      interaction: "Interacción",
      registryLater: "Regístrese más tarde",
      expectedAnswer: "Respuesta esperada",
      firstMenuOption:
        "No es posible crear una opción de menú al comienzo del bot",
      nodeWithoutFather:
        "No es posible poner una opción / pregunta sin un padre",
      optionsMenuInQuestion:
        "La opción del menú no se puede mover a ninguna pregunta.",
      clientsTypes: "Tipos de cliente",
      totalTickets: "Número de tickets de este cliente.",
      agent: "Agente",
      errorImage: "Hubo un error al cargar la imagen.",
      errorVideo: "Hubo un error al cargar lo video.",
      errorAudio: "Hubo un error al cargar lo audio.",
      errorFile: "Hubo un error al cargar lo Archivo",
      companyCategory: "Categorías de empresas",
      noCategoryFound: "No se encontraron categorías",
      registerTrialAccount: "Registro de conta de prueba",
      endTrial: "Su período de prueba ha terminado, comuníquese con lo suporte",
      endTrial1: "Tu cuenta de prueba terminará en",
      endTrial2: "día (s), póngase en contacto con la administración",
      usersLimit: "Limíte de usuários",
      newUserLimit: "Todavía tienes el derecho de levantarte hasta",
      noPermissionToNewUser:
        "Ha alcanzado el límite de usuarios en su cuenta, ¡póngase en contacto con el servicio de asistencia para publicar más!",
      administration: "Administrativo",
      renewForMonth: "Renovar por 1 mês",
      inform: "Informar",
      validDate: "Día de expiración",
      maxUsers: "Usuarios máximos permitidos",
      toleranceDays: "Días de tolerancia",
      reset: "Resetar",
      acessLimitDate: "Fecha límite de acceso",
      offline: "Estás desconectado, comprueba tu conexión a Internet.",
      reconnected: "La conexión ha sido restablecida.",
      contactSuport: "Comuníquese con el soporte para publicar más.",
      loginSugest:
        "Sugerencia de inicio de sesión: company.login. Ejemplo: google.attendant",
      loginExample: "Exemplo: google.atendente",
      accountExpired:
        "Su cuenta ha caducado, póngase en contacto con el servicio de asistencia para seguir usándola.",
      simultaneously: "simultaneamente",
      responsibleEmail: "Correo electrónico responsable",
      responsiblePhone: "Número de teléfono responsable",
      activeUntilThen: "Activo hasta",
      dontHave: "No tiene",
      cantContinueInteraction:
        "No es posible continuar la interacción / opción que redirige a otra interacción.",
      cantContinueEndOfBot:
        "No es posible continuar la interacción / opción que termina el bot o envía a un operador.",
      informactive: "Informativo",
      cantRemoveWithNextInteraction:
        "No es posible eliminar una interacción que redirige a otra, primero elimine la siguiente.",
      detachedInteraction: "Interacción no vinculada",
      timeZone: "Huso horario",
      alreadyHaveAnswer: "Ya tengo una opción con esta respuesta",
      botLinked: "El bot está activo en el canal",
      botLinked2: ", para eliminar desvincular el bot.",
      perTime: "Por tiempo de servicio",
      perAgent: "Informe del pausas",
      totalOfTickets: "Total de entradas",
      assignedTickets: "Entradas asumidas",
      noData: "No se encontraron datos",
      deleteCompany: "Excluir empresa",
      onlyDueDate: "Apenas empresa vencida",
      openIntegration: "Possui integração com o Open",
      informSystem: "Informe o sistema",
      continueBot: "Continuar Bot",
      departments: "Departamentos",
      defaultDepartment: "Departamento estándar",
      deleteDepartment:
        "¿Estás seguro de que deseas eliminar este departamento?",
      departmentDefaultDeleteInformMessage:
        "El departamento se establece como estándar, configure otro departamento como predeterminado para poder eliminarlo.",
      confirmChangeUserProfile: "¿Confirmar cambio de perfil de usuario?",
      changeUserProfile:
        "Al cambiar el perfil del usuario, éste será desvinculado de todas las empresas en las que estaba registrado.",
      notSelectedCompanyDepartmentError:
        "El Usuario deberá ocupar un cargo en todas las empresas en las que vaya a estar registrado.",
      goToDepartment: "Ir al departamento",
      selectDepartment: "Seleccione un departamento",
      department: "Departamento",
      perDepartment: "Por departamento",
      rememberClient: "Recordar al cliente",
      enableRememberClient: "Habilitar notificación/finalización automática",
      maxRememberClientTries:
        "Número máximo de notificaciones antes del cierre automático",
      intervalBetweenRememberClientTries: "Intervalo entre notificaciones",
      rememberClientMessage: "Mensaje de notificación",
      automatiCloseTicketMessage: "Mensaje de cierre automático",
      setTicketTypeToCloseTicket:
        "Debes definir el tipo antes de completar el ticket",
      newBusinessHourTitle: "Nuevo horario de apertura",
      warningStartTimeGreaterThanEndTime:
        "El horario de inicio no puede ser igual o mayor que el horario de cierre",
      warningEndTimeLessThanStartTime:
        "El horario de cierre no puede ser igual o mayor que el horario de inicio",
      members: "Miembros",
    },
  },
}

export { newUserMessages }
